export class Lens {
    get;
    set;
    constructor(get, set) {
        this.get = get;
        this.set = set;
    }
    optional(dfl) {
        const { get, set } = this;
        return new Lens((box) => (box === undefined ? undefined : get(box)), (box, val) => (val === undefined ? undefined : set(box ?? dfl, val)));
    }
    nullable(dfl) {
        const { get, set } = this;
        return new Lens((box) => (box === null ? null : get(box)), (box, val) => (val === null ? null : set(box ?? dfl, val)));
    }
}
//# sourceMappingURL=Lens.js.map